import type { SVGProps } from "react";

/**
 * HandTap icon from Figma - hand with finger tapping gesture
 * SVG paths extracted from Figma design file
 */
export function IconHandTap(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.56 7.25C15.56 6.59339 15.4307 5.94321 15.1794 5.33658C14.9282 4.72995 14.5599 4.17876 14.0956 3.71447C13.6313 3.25017 13.0801 2.88188 12.4735 2.6306C11.8668 2.37933 11.2166 2.25 10.56 2.25C9.90342 2.25 9.25324 2.37933 8.64661 2.6306C8.03998 2.88188 7.48879 3.25017 7.0245 3.71447C6.5602 4.17876 6.19191 4.72996 5.94063 5.33658C5.68936 5.94321 5.56003 6.59339 5.56003 7.25M2.56003 15.25L3.43871 14.3713C4.61028 13.1997 6.50978 13.1997 7.68135 14.3713L8.56003 15.25V7.25C8.56003 6.14543 9.45546 5.25 10.56 5.25C11.6646 5.25 12.56 6.14543 12.56 7.25V12.25H18.56C20.2169 12.25 21.56 13.5931 21.56 15.25V21.25H11.0453C9.45401 21.25 7.92789 20.6179 6.80267 19.4926L2.56003 15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
